import { render, staticRenderFns } from "./ContactTypeAdd.vue?vue&type=template&id=9b1f89ea&scoped=true&"
import script from "./ContactTypeAdd.vue?vue&type=script&lang=js&"
export * from "./ContactTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1f89ea",
  null
  
)

export default component.exports